const navBar = {
  name: 'navBar',
  state: {
    status: 'idle',
    isMaximizedDesktop: true,
    isMaximizedMobile: false,
  },
  reducers: {
    onUpdate(state, props = {}) {
      return { ...state, ...props, status: 'loaded' };
    },
  },
  effects: {
    minimize() {
      const props = {
        isMaximizedDesktop: false,
        isMaximizedMobile: false,
      };
      localStorage.setItem('navBar', JSON.stringify(props));
      this.onUpdate(props);
    },
    toggle(_, { navBar: previousSettings }) {
      const props = {
        isMaximizedDesktop: !previousSettings.isMaximizedDesktop,
        isMaximizedMobile: !previousSettings.isMaximizedMobile,
      };
      localStorage.setItem('navBar', JSON.stringify(props));
      this.onUpdate(props);
    },
    load(overrides) {
      const rs = JSON.parse(localStorage.getItem('navBar'));
      this.onUpdate({
        ...rs,
        ...overrides,
      });
    },
  },
};

export default navBar;
